// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/poll_response/v1/poll_response.proto (package fingertip.creator.poll_response.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreatePollResponseRequest, CreatePollResponseResponse, DeletePollResponseRequest, DeletePollResponseResponse, UpdatePollResponseRequest, UpdatePollResponseResponse } from "./poll_response_pb.js";

/**
 * @generated from rpc fingertip.creator.poll_response.v1.PollResponseService.UpdatePollResponse
 */
export const updatePollResponse = {
  localName: "updatePollResponse",
  name: "UpdatePollResponse",
  kind: MethodKind.Unary,
  I: UpdatePollResponseRequest,
  O: UpdatePollResponseResponse,
  service: {
    typeName: "fingertip.creator.poll_response.v1.PollResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.poll_response.v1.PollResponseService.CreatePollResponse
 */
export const createPollResponse = {
  localName: "createPollResponse",
  name: "CreatePollResponse",
  kind: MethodKind.Unary,
  I: CreatePollResponseRequest,
  O: CreatePollResponseResponse,
  service: {
    typeName: "fingertip.creator.poll_response.v1.PollResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.poll_response.v1.PollResponseService.DeletePollResponse
 */
export const deletePollResponse = {
  localName: "deletePollResponse",
  name: "DeletePollResponse",
  kind: MethodKind.Unary,
  I: DeletePollResponseRequest,
  O: DeletePollResponseResponse,
  service: {
    typeName: "fingertip.creator.poll_response.v1.PollResponseService"
  }
};
